/* eslint-disable react/jsx-props-no-spreading */

import GatewayUpdate from '../GatewayUpdate'
import GatewayComments from '../GatewayComments'

const Overview = ({
    id,
}: { id: number }) => {
    return (
        <>
            <GatewayUpdate
                id={id}
                disabled
            />
            <GatewayComments gatewayId={id} />
        </>
    )
}

export default Overview
